module.exports = __webpack_public_path__ + "img/create-account-office-dark.d34c7b50.jpeg";